export default {
    ACCEPT: 'Принять',
    ACCEPT_ADDITIONAL_AGREEMENT: 'Принять доп соглашение',
    ACCEPT_APPLICATION: 'Принять заявление',
    ACCEPT_DOCUMENT: 'Принять документ',
    ACCEPT_RETURN_ACTION: 'Принять "Вернуть на доработку"',
    ACCEPTED: 'Принят',
    ACCEPTED_THE_APPLICATION: '<span class="font-medium">:author</span> принял(а) заявление',
    ACCESS_DENIED: 'В доступе отказано',
    ACCESS_DENIED_DESCRIPTION: 'К сожалению, у вас нет разрешения на доступ к этой странице.',
    ACCOUNT_NUMBER: 'Номер счета',
    ACCOUNTANT: 'Бухгалтер',
    ACTION: 'Действие',
    ACTIONS: 'Действия',
    ACTION_REASON: 'Пожалуйста, опишите причину действия',
    ACTIVATION_CODE: 'Код активации',
    ACTIVATION_CODE_SENT_TO_TELEGRAM: 'Код активации отправлен вам на телеграм',
    ACTIVATION_TELEGRAM: 'Активация телеграм',
    ADD: 'Добавить',
    ADD_ADDRESS: 'Добавить адрес',
    ADD_ANSWER: 'Добавить ответ',
    ADD_CERTIFICATE_OR_LICENSE_FILE: 'Добавьте файл сертификата или лицензии',
    ADD_EMPLOYMENT: 'Добавить пользователя',
    ADD_EXECUTOR: 'Добавить исполнителя',
    ADD_EXECUTORS: 'Добавить исполнителей',
    ADD_FILE: 'Добавить файл',
    ADD_FILES: 'Добавить файлы',
    ADD_INDICATORS: 'Добавление показателей',
    ADD_SIGNERS: 'Добавить согласующих',
    ADD_TELEGRAM_USER_ID: 'Добавить Телеграм "user ID"',
    ADDED_AS_A_SIGNER_TO_RESOLUTION: '<span class="font-medium">:employee</span> назначен(а) согласующим резолюции',
    ADDED_AS_AN_EXECUTOR_TO_RESOLUTION: '<span class="font-medium">:employee</span> назначен(а) исполнителем резолюции',
    ADDED_TO_APPLICATION: '<span class="font-medium">:employee</span> добавлено в заявление',
    ADDING_AN_ADDRESS: 'Добавление адреса',
    ADDING_CUSTOMER_INFORMATION: 'Добавление сведения о заказчике',
    ADDING_DOCUMENTS: 'Добавление документов',
    ADDITIONAL_AGREEMENT: 'Дополнительное соглашение',
    ADDITIONAL_AGREEMENT_SHORT: 'ДС',
    ADDITIONAL_EXPERTISE: 'Виды дополнительных экспертиз',
    ADDITIONAL_FILE: 'Дополнительный файл',
    ADDITIONAL_FILES: 'Дополнительные файлы',
    ADDITIONAL_TERMS_OF_THE_PARTIES: 'Дополнительные условия сторон',
    ADDRESS: 'Адрес',
    ADMINISTRATOR: 'Администратор',
    AGREED: 'Согласующий',
    AGREEDS: 'Согласующие',
    AGREEMENT: 'Договор',
    AGREEMENT_CREATE: 'Создание договора',
    AGREEMENT_DATE_AND_TIME: 'Дата и время договора',
    AGREEMENT_DEADLINE: 'Срок договора',
    AGREEMENT_EDIT: 'Редактирование договора',
    AIMAK: 'Аймак',
    ALL: 'Все',
    ALSO_MAIN_CUSTOMER: 'Сделать основным заказчиком',
    ANSWER: 'Ответ',
    ANSWER_CONFIRM: 'Согласовать ответ',
    ANSWER_TYPE: 'Тип ответа',
    ANSWERED: 'Ответы',
    ANSWERED_TO_RESOLUTION: '<span class="font-medium">:author</span> ответил(а) на резолюцию',
    ANSWERS: 'Ответы',
    APP_NAME: 'Госстрой',
    APPLICANT: 'Заявитель',
    APPLICANT_CONSTRUCTOR: 'Заявитель/Проектировщик',
    APPLICANT_DATA: 'Данные о заявителе',
    APPLICANT_INFORMATION: 'Сведение о заявителе проекта',
    APPLICANT_INFORMATION_CREATE: 'Создание сведение о заявителе проекта',
    APPLICANT_INFORMATION_EDIT: 'Редактирование сведение о заявителе проекта',
    APPLICANT_PATRONYMIC: 'Отчество заявителя/проектировщика',
    APPLICANT_SURNAME: 'Фамилия заявителя/проектировщика',
    APPLICATION: 'Заявление',
    APPLICATION_ACCEPTED: 'Заявление принято',
    APPLICATION_CREATE: 'Создание заявления',
    APPLICATION_EDIT: 'Редактирование заявления',
    APPLICATION_IS_NOT_GENERATED: 'Заявление не сгенерировано',
    APPLICATION_NEXT_STATUS: 'Следующий статус заявления',
    APPLICATION_NUMBER: 'Номер заявления',
    APPLICATION_SENT_TO_EXPERTIZE: 'Заявка отправлена на экспертизу!',
    APPLICATION_STATUS: 'Статус заявления',
    APPLICATION_STATUSES: 'Статусы заявлений',
    APPLICATIONS: 'Заявления',
    APPLICATIONS_LIST_EMPTY: 'Список заявлений пуст',
    APPLICATIONS_LIST_TITLE: 'Заявления',
    APPOINTMENT: 'Назначение объекта',
    ARE_YOU_SURE_TO_DELETE: 'Вы уверены что хотите удалить?',
    ARE_YOU_SURE_TO_RESET_DEFAULT_SETTINGS: 'Вы уверены что хотите сбросить настройки по умолчанию?',
    ASSIGN: 'Назначить',
    ASSIGN_CLOSING_SIGNER: 'Назначить закрывающую подпись',
    ASSIGN_ACCOUNTANT: 'Назначить бухгалтера',
    ASSIGN_CURATOR: 'Назначить отдел куратор',
    ASSIGN_PAYER: 'Назначить плательщика',
    ASSIGN_RESPONSIBLE: 'Назначить ответственного',
    ASSIGNED_AS_A_CURATOR_TO_RESOLUTION: '<span class="font-medium">:employee</span> назначен(а) куратором резолюции',
    ASSIGNED_AS_A_RESPONSIBLE_TO_RESOLUTION: '<span class="font-medium">:employee</span> назначен(а) ответственным резолюции',
    ATTACH_ADDITIONAL_AGREEMENT: 'Прикрепить дополнительное соглашение',
    ATTACH_CONFIRMATION_DOCUMENT: 'Прикрепить подтверждающий документ ',
    ATTACH_CORRECTION_LETTER: 'Прикрепить письмо об устранении замечаний',
    ATTACH_FILE: 'Прикрепить файл',
    ATTACH_FILES: 'Прикрепить файлы',
    ATTACH_PAYMENT_ORDER: 'Прикрепить платежное поручение',
    ATTACHED_FILES: 'Прикрепленные файлы',
    ATTENTION: 'Внимание!',
    ATTENTION_DESCRIPTION: 'Для создания заявления вам необходимо полностью заполнить свой профиль',
    AUTHENTICATION: 'Авторизация',
    AUTHOR: 'Автор',
    AVATAR: 'Аватар',
    BACK: 'Назад',
    BANK_DATA: 'Банковские данные',
    BANK_DETAILS: 'Банковские реквизиты',
    BANK_NAME: 'Наименование банка',
    BASIS_FOR_ADDITIONAL_AGREEMENTS: 'Основание для заключения доп. соглашения',
    BIK: 'БИК',
    BIRTH_DATE: 'Дата рождения',
    BLOCKING: 'Блокировка',
    BRANCH: 'Филиал',
    BY_CLICKING_START_BUTTON: 'нажав на кнопку "start"',
    BY_DATE_OF_RECEIPT: 'По дате поступления',
    BY_DATE_OF_REGISTRATION: 'По дате регистрации',
    BY_DATE_OF_EXECUTION: 'По дате исполнения',
    CALCULATION_OF_THE_TOTAL_AMOUNT: 'Расчет общей суммы',
    CALCULATOR: 'Калькулятор',
    CANCEL: 'Отмена',
    CATEGORY: 'Категория',
    CERTIFICATE_NUMBER: 'Номер сертификата',
    CERTIFICATE_NUMBER_LICENSES: 'Номер сертификата/лицензии',
    CERTIFYING_DOCUMENTS: 'Правоудостоверяющие документы',
    CERTIFYING_ESTABLISHING_DOCUMENTS: 'Правоудостоверяющие документы/Правоустанавливающие документы',
    CHANGE_IN_PROCESS_REJECTED: 'Изменение в рабочем порядке отклонено',
    CHANGE_REASON: 'Причина изменения',
    CHANGE_REJECTED: 'Изменение отклонено',
    CHANGE_REQUEST: 'Запрос на изменение',
    CHAPTER: 'Глава',
    CHECK_EMAIL_FOR_PASSWORD_RESET: 'Проверьте свою электронную почту и откройте ссылку, которую мы отправили, чтобы продолжить',
    CHILDREN_ANSWERS: 'Сводные ответы',
    CHOOSE_FILE: 'Выберите файл',
    CHOOSE_FILES: 'Выберите файлы',
    CITIZENSHIP: 'Гражданства',
    CIVIL: 'Государственный',
    CLOSE: 'Закрыть',
    CLOSED_THE_RESOLUTION: '<span class="font-medium">:author</span> закрыла(а) резолюцию',
    CLOSING_SIGNER: 'Закрывающая подпись',
    CLOSING_SIGNER_SHORT: 'З',
    CODE: 'Код',
    CODE_OF_BANK_REQUISITE: 'Код банковского реквизита',
    COMMENTS: 'Комментарии',
    COMPLETED: 'Завершен',
    COMPLETION: 'Завершение',
    CONCLUSION: 'Заключение',
    CONCLUSION_NUMBER: 'Номер заключения',
    CONFIDANT: 'Доверенное лицо',
    CONFIDANT_INFORMATION_CREATE: 'Добавить доверенное лицо',
    CONFIDANT_INFORMATION_EDIT: 'Редактировать доверенное лицо',
    CONFIRM: 'Подтвердить',
    CONFIRM_PASSWORD: 'Повторите пароль',
    CONFIRM_PAYMENT: 'Подтвердить оплату',
    CONFIRMED: 'Подтвержден',
    CONFIRMED_THE_RESOLUTION_ANSWER: '<span class="font-medium">:author</span> согласовал(а) ответ резолюции',
    CONSTRUCTION_TYPE: 'Вид строительства',
    CONSTRUCTOR: 'Проектировщик',
    CONSTRUCTOR_DATA: 'Данные о проектировщике',
    CONTACT_DETAILS: 'Контактные данные',
    CONTACTS: 'Контакты',
    CONTACTS_DATA: 'Контактные данные',
    CONTRACT_SUBJECT: 'Предмет Договора',
    COPY_USER_ID_HERE: 'Скопируйте user ID сюда',
    CORRECTION_LETTER: 'Письмо об устранении замечаний',
    COST_CALCULATION: 'Расчет стоимости',
    CREATE: 'Создать',
    CREATE_ACCOUNT: 'Создать аккаунт',
    CREATION_DATE: 'Дата создания',
    CREATION_DATE_FROM: 'Дата создания от',
    CREATION_DATE_TO: 'Дата создания до',
    CURATOR: 'Куратор',
    CURATOR_SHORT: 'К',
    CUSTOMER: 'Заказчик',
    CUSTOMER_CONTACT_EMAIL: 'Электронный адрес заказчика',
    CUSTOMER_CONTACT_NAME: 'Имя контакта с заказчиком',
    CUSTOMER_CONTACT_PATRONYMIC: 'Отчество контакта с заказчиком',
    CUSTOMER_CONTACT_PHONE: 'Телефон номер заказчика',
    CUSTOMER_CONTACT_PHONE_WORK: 'Рабочий телефон заказчика',
    CUSTOMER_CONTACT_SURNAME: 'Фамилия контакта с заказчиком',
    CUSTOMER_DATA: 'Данные о заказчике',
    CUSTOMER_INFORMATION: 'Сведение о заказчике проекта',
    CUSTOMER_INFORMATION_CREATE: 'Создание сведение о заказчике проекта',
    CUSTOMER_INFORMATION_EDIT: 'Редактирование сведение о заказчике проекта',
    CUSTOMER_IS_APPLICANT: 'Заказчик заявитель',
    CUSTOMER_NAME: 'Имя заказчика',
    CUSTOMER_OWNER: 'Действительно, я являюсь Заказчиком данного проекта',
    CUSTOMER_PROJECT: 'Заказчик проекта',
    CUSTOMERS_EDIT_WARNING: 'Предупреждение за редактирование',
    DATA_TYPE_ERROR: 'Ошибка типа данных',
    DATE: 'Дата',
    DATE_OF_ISSUE: 'Дата выдачи',
    DEADLINE: 'Срок',
    DELETE: 'Удалить',
    DENOMINATION: 'Наименование',
    DEPARTMENT: 'Отдел',
    DEPARTMENT_CURATOR: 'Отдел куратор',
    DEPARTMENT_RESPONSIBLE: 'Отдел "О" исполнитель',
    DEPARTMENTS: 'Отделы',
    DETAIL: 'Детали',
    DESIGNER_DEVELOPER: 'Проектировщик/Разработчик',
    DIRECTOR: 'Директор',
    DISTRIBUTION: 'Распределения',
    DISTRICT: 'Район',
    DOCUMENT: 'Документ',
    DOCUMENT_APPLICANT_SELF_OWNER: 'Действительно, я являюсь проектировщиком данного проекта',
    DOCUMENT_CREATE: 'Создание документа',
    DOCUMENT_DENOMINATION: 'Наименование документа',
    DOCUMENT_EDIT: 'Редактирование документа',
    DOCUMENT_HISTORY: 'История документа',
    DOCUMENT_NUMBER: '№ Документа',
    DOCUMENT_REMARKS: 'Замечания к документу',
    DOCUMENT_TYPE: 'Тип документа',
    DOCUMENTS: 'Документы',
    DOCUMENTS_CREATE: 'Создание документов',
    DOCUMENTS_EDIT: 'Редактирование документов',
    DOCUMENTS_LIST_EMPTY: 'Документов нет',
    DOCUMENTS_VERSION: 'Версия документов',
    DOWNLOAD: 'Скачать',
    DOWNLOAD_FILES: 'Скачать файлы',
    EDIT: 'Редактировать',
    EDIT_ADDRESS: 'Редактировать адрес',
    EDIT_PERSONAL_DATA: 'Редактирование персональных данных',
    EDIT_REMARKS: 'Исправить замечание',
    EGRZ: 'Заявления ЕГРЗ',
    EMAIL: 'Электронная почта',
    EMAIL_SENT: 'Письмо отправлено',
    EMPLOYEE: 'Сотрудник',
    EMPLOYEES: 'Сотрудники',
    EMPTY: 'Пусто',
    ENTER: 'Введите',
    ENTER_CONCLUSION_NUMBER: 'Введите номер заключения',
    ENTER_EMAIL: 'Введите электронную почту',
    ENTER_PASSWORD: 'Введите пароль',
    ENTER_PIN_FOR_CLOUD_SIGN: 'Введите пин код электронной подписи',
    ENTER_PROJECT_DENOMINATION: 'Введите наименование заявления',
    ENTER_YOU_PIN: 'Введите ваш 14 значный ПИН',
    ENTER_REASON: 'Введите причину',
    ENTITLEMENT_DOCUMENTS: 'Правоустанавливающие документы',
    EXCLUDING_TAXES: 'без учета налогов',
    EXECUTOR_NAME: 'Имя исполнителя',
    EXECUTOR_PATRONYMIC: 'Отчество исполнителя',
    EXECUTOR_SURNAME: 'Фамилия исполнителя',
    EXECUTORS: 'Исполнители',
    EXPERT_OBJECT: 'Объект экспертизы',
    EXPERT_TYPE: 'Вид экспертизы',
    EXPERTIZE: 'Экспертиза',
    EXPERTIZE_DEADLINE: 'Срок проведения экспертизы',
    EXPERTIZE_PAYMENT_SOURCE: 'Источник оплаты экспертизы',
    EXPIRATION_DATE: 'Дата окончания',
    EXTRABUDGETARY_FUNDS: 'Внебюджетные средства',
    FACILITY_INFORMATION: 'Сведение по объекту',
    FACILITY_INFORMATION_CREATE: 'Создание сведение по объекту',
    FACILITY_INFORMATION_EDIT: 'Редактирование сведение по объекту',
    FAMILIARIZE: 'Ознакомлен',
    FILE: 'Файл',
    FILE_CERTIFICATE_LICENSES: 'Файл сертификата/лицензии',
    FILES: 'Файлы',
    FILL_PROFILE: 'Заполнить профиль',
    FIND: 'Найти',
    FIRST_FILL_PREVIOUS_STEPS: 'Сначало заполните предыдущие шаги',
    FLOOR: 'Этаж',
    FOR_SIGN: 'На подписании',
    FORGOT_PASSWORD: 'Забыли пароль?',
    FOOTER_DESCRIPTION: 'Описания',
    FROM_APPLICANT: 'В лице',
    FROM_APPLICANT_HINT_TEXT: '<p class="mb-2">Необходимо продолжить текст и ввести для: ' + '<br/>' +
        '- физических лиц и ИП И.О. Фамилию (в родительном падеже)' + '<br>' +
        '- юридических лиц ввести должность (в родительном падеже), наименование организации и И.О. Фамилию (в родительном падеже).' +
        '</p>' +
        '<p>Пример отображения после заполнения:</p>' +
        '<p class="italic">' +
        '«Мы, нижеподписавшиеся, Департамент государственной экспертизы в лице директора  Асанов А.А., действующего на основании Положения, именуемый в дальнейшем «Исполнитель» с одной стороны, и директора ОАО «Солнечный» в лице Т.А. Асанова, именуемый в дальнейшем «Заказчик», с другой стороны, заключили настоящий договор…»' +
        '</p>',
    FROM_APPLICANT_TEXT: 'Мы, нижеподписавшиеся, Департамент государственной экспертизы в лице директора Ф.И.О, действующего на основании Положения, именуемый в дальнейшем «Исполнитель» с одной стороны, и ',
    FROM_APPLICANT_POSITION_FULLNAME: 'В лице (должность и ФИО)',
    FROM_WHOM: 'От кого',
    FULL_NAME: 'ФИО',
    GENERAL_INFORMATION: 'Общие сведения',
    GENERAL_REPORT: 'Общий отчет',
    GENERAL_REPORT_BY_REGIONS: 'Общий отчет по регионам',
    GENERAL_REPORT_BY_OBJECT_TYPES: 'Общий отчет по видам объекта',
    GENERATE: 'Генерировать',
    GENERATE_FILE: 'Сформировать файл',
    GENERATE_APPLICATION_AND_SIGN: 'Генерировать заявление и подписать',
    GENERATED_AGREEMENT: 'Сгенерированный договор',
    GENERATED_APPLICATION: 'Сгенерированное заявление',
    GET_TELEGRAM_USER_ID: 'Получить Телеграм "user ID"',
    GO_BACK: 'Вернуться назад',
    GO_BACK_TO_RESOLUTIONS: 'Вернуться назад к резолюциям',
    GOV_ORGANIZATION: 'Госорган',
    HAVE_A_PROFILE_LOGIN: 'Есть профиль? Авторизоваться',
    HEADING: 'Заголовок',
    HIDE_FILE: 'Скрыть файл',
    HISTORY: 'История',
    HOUSE: 'Дом',
    IN_PROCESS: 'На исполнении',
    IN_PROCESS_REMARK: 'Замечания в рабочем порядке',
    IN_PROCESS_REMARK_WARNING: 'Вы уверенны? При нажатии на кнопку "Сохранить" Ваше замечание станет доступно заявителю',
    INBOX: 'Входящий',
    INBOXES: 'Входящие',
    INDICATOR_DESIGNATION: 'Обозначение показателя',
    INDIVIDUAL_ENTERPRISE_CODE: 'Код индивидуального предпринимателя',
    INDIVIDUAL_ENTERPRISE_FIRST_REGISTER_DATE: 'Дата первичной регистрации',
    INDIVIDUAL_ENTERPRISE_LAST_REGISTER_DATE: 'Дата последней перерегистрации',
    INDIVIDUAL_ENTERPRISE_LEGAL_FORM: 'Организационно – правовая форма',
    INDIVIDUAL_ENTERPRISE_REGISTER_NUMBER: 'Регистрационный номер',
    INDIVIDUAL_ENTERPRISE_TAX_CODE_NAME: 'Код и наименование налогового органа',
    INDIVIDUAL_ENTITY: 'Физическое лицо',
    INDIVIDUAL_ENTREPRENEUR: 'Индивидуальный предприниматель',
    INFORMATION: ' Сведения',
    INFORMATION_ABOUT_CUSTOMER: ' Сведения о заказчике проекта',
    INFORMATION_ABOUT_THE_CUSTOMER_OF_THE_PROJECT: 'Сведение о заказчике проекта',
    INFORMATION_ABOUT_THE_APPLICANT_DESIGNER: ' Сведения о заявителя/проектировщика ',
    INFORMATION_ABOUT_THE_OBJECT: 'Сведения по объекту',
    INITIAL_DATA: 'Краткие исходные данные',
    INITIAL_PERMIT_DOCUMENTATION: 'Исходно-разрешительная документация',
    INN: 'ИНН',
    INN_PIN: 'ИНН/ПИН',
    INVOICE_FOR_PAYMENT: 'Счет на оплату',
    IS_OWNER: 'Действительно, я являюсь заказчиком данного проекта',
    ISSUED_BY: 'Орган выдавший',
    ISSUED_DATE: 'Дата выдачи',
    KG: 'KG',
    KYRGYZ: 'Кыргызский',
    LAST_SELECTED_EMPLOYEES: 'Последние выбранные сотрудники',
    LAWYER: 'Юрист',
    LEADS: 'Сводящие',
    LEGAL_ENTITY: 'Юридическое лицо',
    LETTER_FILE: 'Файл письма',
    LIST_EMPTY: 'Список пуст',
    LOCATION_CATEGORY: 'Категория объекта',
    LOCATION_TYPE: 'Вид объекта',
    LOGIN: 'Логин',
    LOGIN_AS_EMPLOYEE: 'Войти как сотрудник',
    LOGOUT: 'Выйти',
    MAIN_BANK_ACCOUNT: 'Основной расчётный счёт',
    MAIN_CUSTOMER: 'Основной заказчик',
    MAIN_CUSTOMER_SIGN_PENDING: 'Ожидается подписание со стороны основного Заказчика',
    MAIN_INFORMATION: 'Основная информация',
    MAIN_STATUS: 'Основной статус',
    MAIN_TECHNO_ECONOMIC_INDICATORS_OF_OBJECT: 'Основные технико-экономические показатели объекта КС',
    MAIN_TECHNO_ECONOMIC_INDICATORS_OF_OBJECT_CREATE: 'Создание Основные технико-экономические показатели объекта КС',
    MAIN_TECHNO_ECONOMIC_INDICATORS_OF_OBJECT_EDIT: 'Редактирование Основные технико-экономические показатели объекта КС',
    MANAGER: 'Управляющий',
    MANUAL: 'Справочник',
    MARK_AS_READ: 'Пометить, как прочитанное',
    MESSAGE: 'Сообщение',
    MIDDLE_NAME: 'Отчество',
    MORE: 'Ещё',
    MUNICIPAL: 'Муниципальный',
    MY_APPLICATIONS: 'Мои заявления',
    NAME: 'Имя',
    NAME_OF_CALCULATION: 'Наименование объекта расчета',
    NDS: 'НДС',
    NEED_TO_PASS_EXTRA_TYPES_OF_EXPERTIZE: 'Необходимо ли прохождение дополнительных видов экспертиз',
    NEGATIVE_ANSWER: 'Заключение отрицательное',
    NEW_APPLICATION: 'Новое заявление',
    NEXT: 'Далее',
    NEXT_STATUS: 'Следующий статус',
    NO: 'Нет',
    NO_FILE_CHOSEN: 'Файл не выбран',
    NO_PROFILE_REGISTER: 'Нет профиля? Зарегистрироваться',
    NOT_CONFIRMED: 'Не подтвержден',
    NOT_FOUND: 'Не найдено',
    NOTIFICATIONS: 'Уведомления',
    NOTIFICATIONS_EMPTY: 'Пока нет уведомлений',
    NSP: 'НСП',
    NUMBER: 'Номер',
    OBJECT_CATEGORY: 'Категория объекта',
    OBJECT_EXPERTIZE: 'Объект экспертизы',
    OBJECT_INDICATORS: 'Показатели объекта',
    OBJECT_IS_STRATEGIC: 'Является объект строительства стратегическим',
    OBJECT_NAME: 'Наименование объекта',
    OBJECT_POSTAL_ADDRESS: 'Почтовый (строительный) адрес объекта капитального строительства',
    OBJECT_TYPE: 'Вид объекта',
    OKPO: 'ОКПО',
    ON_CONFIRM: 'На рассмотрении',
    ON_PENDING: 'В ожидании',
    ON_DISABILITY: 'Больничный до :end, от :start',
    ON_TRIP: 'Командировка до :end, от :start',
    ON_VACATION: 'Отпуск до :end, от :start',
    ORG_CHIEF_NAME: 'Имя руководителя организации',
    ORG_CHIEF_PATRONYMIC: 'Отчество руководителя организации',
    ORG_CHIEF_SURNAME: 'Фамилия руководителя организации',
    ORG_NAME: 'Наименование организации',
    ORG_NAME_KG: 'Наименование организации (kg)',
    ORG_NAME_RU: 'Наименование организации (ru)',
    ORGANIZATION_CHIEF_INN: 'Пин руководителя',
    ORGANIZATION_CHIEF_NAME: 'Имя руководителя',
    ORGANIZATION_CHIEF_PATRONYMIC: 'Отчество руководителя',
    ORGANIZATION_CHIEF_SURNAME: 'Фамилия руководителя',
    ORGANIZATION_FIRST_REGISTER_DATE: 'Дата первичной регистрации',
    ORGANIZATION_FOREIGN_INFO: 'Сведения об иностранном участии',
    ORGANIZATION_LEGAL_FORM: 'Организационно-правовая форма',
    ORGANIZATION_LEGAL_UNIT_CODE: 'Код юридического лица',
    ORGANIZATION_LAST_REGISTER_DATE: 'Дата последней перерегистрации',
    ORGANIZATION_NAME_KG: 'Полное наименование на государственном языке',
    ORGANIZATION_NAME_RU: 'Полное наименование на официальном языке',
    ORGANIZATION_OKPO: 'Код ОКПО',
    ORGANIZATION_REGISTER_NUMBER: 'Регистрационный номер',
    ORGANIZATION_SHORT_NAME_KG: 'Сокращённое наименование на государственном языке',
    ORGANIZATION_SHORT_NAME_RU: 'Сокращённое наименование на официальном языке',
    ORGANIZATION_ADDRESS: 'Сведения об адресе (месте нахождения) юридического лица, филиала (представительства)',
    OTHER: 'Другое',
    OWNERSHIP_FORM: 'Форма собственности',
    PASSPORT_DATA: 'Паспортные данные',
    PASSPORT_INFO: 'Паспортные данные',
    PASSPORT_NUMBER: 'Номер паспорта',
    PASSPORT_SERIAL: 'Серия',
    PASSWORD: 'Пароль',
    PASSWORD_CONTAINS: 'Пароль должен содержать не менее 5 знаков: буквы латинского алфавита (хотя бы 1 заглавную) и хотя бы 1 цифру',
    PASSWORD_LENGTH: 'Пожалуйста, введите пароль длиннее 5 символа',
    PASSWORD_MUST_MATCH: 'Пароли должны совпадать',
    PASSWORD_REPEAT: 'Повторить пароль',
    PASSWORD_RESET: 'Пароль был изменен',
    PATRONYMIC: 'Отчество',
    PAY: 'Оплатить',
    PAYER: 'Плательщик',
    PAYMENT: 'Оплата',
    PAYMENT_CONFIRMED: 'Оплата подтверждена',
    PAYMENT_CHANGE_REQUEST: 'Запрос на изменение оплаты',
    PAYMENT_GENERATED: 'Оплата сформировано',
    PAYMENT_HISTORY: 'История оплаты',
    PAYMENT_NOT_CALCULATED_YET: 'Оплата еще не рассчитана',
    PAYMENT_NOT_REQUIRED: 'Оплата не требуется',
    PAYMENT_ON_SIGN: 'Оплата на подписании',
    PAYMENT_ORDER: 'Платежное поручение',
    PAYMENT_STATUS: 'Статус оплаты',
    PAYMENT_TYPE: 'Способ оплаты',
    PENDING_CONFIRM: 'Ожидает подтверждения',
    PERMISSION_DENIED: 'Доступ запрещен',
    PERMISSION_REQUEST: 'Запрос доступа',
    PERSONAL_DATA: 'Личные данные',
    PERSONAL_DATA_AGREEMENT: 'Я согласен на обработку персональных данных',
    PERSONAL_DATA_AUTHENTICITY: 'Я подтверждаю достоверность заполненных мною данных и подлинность представленных документов',
    PERSONAL_DATA_PERMISSION_FORM: 'Форма согласия на обработку персональных данных',
    PERSONAL_DATA_UPDATED_SUCCESSFULLY: 'Профиль успешно обнавлен!',
    PHONE: 'Телефон',
    PIN: 'Пин',
    PLANNER: 'Проектировщик',
    PLANNER_INFORMATION: 'Сведение о проектировщике',
    PLANNER_INFORMATION_CREATE: 'Создание сведение о проектировщике',
    PLANNER_INFORMATION_EDIT: 'Редактирование сведение о проектировщике',
    PLOT: 'Участок',
    POSITION: 'Должнось',
    POSITIONS: 'Должности',
    POSITIVE_ANSWER: 'Заключение положительное',
    PREVIEW: 'Просмотр',
    PRESENTED_DATA: 'На рассмотрение представлены',
    PRIVATE: 'Частное',
    PROFILE: 'Профиль',
    PROJECT_DENOMINATION: 'Наименование проекта',
    PROJECT_MAIN_ARCHITECT: 'Главный архитектор проекта (ГАП)',
    PROJECT_MAIN_ARCHITECT_CREATE: 'Создание главного архитектора проекта (ГАП)',
    PROJECT_MAIN_ARCHITECT_EDIT: 'Редактирование главного архитектора проекта (ГАП)',
    PROJECT_MAIN_ENGINEER: 'Главный инженер проекта (ГИП)',
    PROJECT_MAIN_ENGINEER_CREATE: 'Создание главного инженера проекта (ГИП)',
    PROJECT_MAIN_ENGINEER_EDIT: 'Редактирование главного инженера проекта (ГИП)',
    PROJECT_NAME: 'Наименование объекта (проекта) строительства (как в АГЗ)',
    PROJECT_USERS: 'Пользователи проекта',
    PURPOSE_OF_OBJECT: 'Назначение объекта',
    PURPOSE_OF_OBJECT_TYPE: 'Назначение типа объекта',
    REASON: 'Причина',
    REASSIGN: 'Переназначить',
    REASSIGN_EMPLOYEE: 'Переназначить сотрудника',
    REASSIGN_PAYER: 'Переназначить плательщика',
    RECEIPT: 'Квитанция',
    RECEIPT_DATE: 'Дата поступления',
    REFUSE: 'Отказать',
    REFUSE_APPLICATION: 'Отклонить заявление',
    REFUSE_DOCUMENT: 'Отклонить документ',
    REFUSED: 'Отказано',
    REFUSED_THE_APPLICATION: '<span class="font-medium">:author</span> отклонил(а) заявление',
    REGENERATE_APPLICATION: 'Сгенерировать заявление заново',
    REGION: 'Область/Город',
    REGISTER: 'Регистрация',
    REGISTRATION_ACCESS_REGISTRATION_COMPLETED_SUCCESSFULLY: 'Регистрация прошла успешно',
    REGISTRATION_CONFIRM_EMAIL_TEXT: 'Для входа подтвердите свой Email, ссылка направлена  на ваш электронный адрес, указанный в регистрации.',
    REGISTRATION_DATE: 'Дата регистрации',
    REGISTRATION_DATE_FROM: 'Дата регистрации от',
    REGISTRATION_DATE_TO: 'Дата регистрации до',
    REJECT: 'Отклонить',
    REJECT_CHANGE: 'Отклонить изменение',
    REJECTED: 'Отклонено',
    REJECTION_REASON: 'Причина отклонения',
    REMARK: 'Замечание',
    REMARKS: 'Замечания',
    REMARKS_CORRECTION: 'Устранение замечаний',
    REPEATED_EXPERTIZE: 'Повторная экспертиза',
    REPORT_BY_EMPLOYEE: 'Отчет по сотрудникам',
    REPORTS: 'Отчеты',
    REPORTS_TYPE: 'Виды отчета',
    REQUEST_DATE: 'Дата запроса',
    REQUEST_PROCESSED: 'Запрос уже обработан',
    RESEND: 'Переназначить',
    RESET: 'Сбросить',
    RESET_DEFAULT_SETTINGS: 'Сбросить настройки по умолчанию',
    RESOLUTION: 'Резолюция',
    RESOLUTION_TYPE: 'Тип резолюции',
    RESOLUTIONS: 'Резолюции',
    RESPONSIBLE: 'Ответственный',
    RESPONSIBLE_SHORT: 'О',
    RESTORE: 'Восстановить',
    RESTORING_THE_PROFILE: 'Восстановление профиля',
    RETURN: 'Вернуть',
    RETURN_ADDITIONAL_AGREEMENT_TO_REWORK: 'Вернуть доп соглашение на доработку',
    RETURN_APPLICATION_TO_REWORK: 'Вернуть заявление на доработку',
    RETURN_APPLICATION_SECTIONS_TO_REWORK: 'Вернуть резолюции на доработку',
    RETURN_DOCUMENT: 'Вернуть на доработку',
    RETURN_TO_MAIN_PAGE: 'Вернутся на главную',
    RETURNED_FOR_REVISION: 'Возвращено на доработку',
    RETURNED_THE_APPLICATION_TO_REWORK: '<span class="font-medium">:author</span> вернул(а) на доработку заявлению',
    RETURNED_TO_REWORK_THE_RESOLUTION: '<span class="font-medium">:author</span> вернул(а) на доработку резолюцию',
    ROLE: 'Роль',
    ROLES: 'Роли',
    ROUTES: 'Маршруты',
    RU: 'RU',
    RUSSIAN: 'Русский',
    SAVE: 'Сохранить',
    SEARCH: 'Поиск',
    SECTION: 'Раздел',
    SECTION_FILES: 'Файлы раздела',
    SECTIONS: 'Разделы',
    SELECT_AGREEDS: 'Выбрать согласующих',
    SELECT_ALL: 'Выбрать всех',
    SELECT_EXECUTORS: 'Выбрать исполнителей',
    SELECT_FROM_OPTIONS: 'Выберите из списка',
    SELECTED_EXECUTORS: 'Выбранные исполнители',
    SEND: 'Отправить',
    SEND_DATE: 'Дата отправки',
    SEND_DATE_FROM: 'Дата отправки от',
    SEND_DATE_TO: 'Дата отправки до',
    SEND_FOR_REVISION: 'Отправить на доработку',
    SEND_LINK_TO_EMAIL: 'Отправить ссылку на почту',
    SEND_REMARKS_TO_EXPERTIZE: 'Отправить замечание на экспертизу',
    SEND_TO_EXPERTIZE: 'Отправить на экспертизу',
    SENT_CHANGE_REQUEST: 'Отпрален запрос на изменение',
    SENT_THE_CONCLUSION_OF_THE_APPLICATION_TO_THE_APPLICANT: '<span class="font-medium">:author</span> отправил(а) заключение заявления к заявителю',
    SERIAL_NUMBER: 'Серийные номер',
    SERIES: 'Серия',
    SHORT_DENOMINATION: 'Сокращённое наименование',
    SHOW_FILE: 'Показать файл',
    SIGN: 'Подписать',
    SIGNER: 'Подписант',
    SIGN_ADDITIONAL_AGREEMENT: 'Подписать доп соглашение',
    SIGN_AGREEMENT: 'Подписать договор',
    SIGN_ALL: 'Подписать все',
    SIGN_ALL_DOCUMENTS: 'Подписать все документы',
    SIGN_CONCLUSION: 'Подписать заключение',
    SIGN_DATE: 'Дата подписи',
    SIGN_DOCUMENT: 'Подписать документ',
    SIGN_IN: 'Войти',
    SIGN_PAYMENT: 'Подписать оплату',
    SIGN_REMARK: 'Подписать замечание',
    SIGN_RESOLUTION_ANSWER: 'Подписать ответ резолюции',
    SIGN_AN_INVOICE_FOR_PAYMENT: 'Подписать счет на оплату',
    SIGNATURE: 'Подпись',
    SIGNED_BY: 'Подписал(а)',
    SIGNED_DATE: 'Дата подписания',
    SIGNED_THE_RESOLUTION: '<span class="font-medium">:author</span> подписал(а) резолюцию',
    SIGNED_THE_RESOLUTION_ANSWER: '<span class="font-medium">:author</span> подписал(а) ответ резолюции',
    SIGNED_THE_RESOLUTION_CONCLUSION: '<span class="font-medium">:author</span> подписал(а) заключение резолюции',
    SIGNED_THE_RESOLUTION_REMARKS: '<span class="font-medium">:author</span> подписал(а) замечании резолюции',
    SINGLE_WINDOW: 'Единое окно',
    SOM: 'сом',
    STATE: 'Госорган',
    STATE_BUDGET: 'Государственный бюджет',
    STATUS: 'Статус',
    STATUSES: 'Статусы',
    STREET: 'Улица',
    SUB_DIRECTOR: 'Замиститель директора',
    SUBDIVISION: 'Подразделение',
    SUBDIVISIONS: 'Подразделения',
    SUBMIT: 'Подтвердить',
    SUBSCRIBE_TO_TELEGRAM_BOT: 'Подписаться на телеграм бот',
    SUCCESS_ACTION: 'Успешное действие!',
    SUM: 'Сумма',
    SUPPLEMENT: 'Приложение',
    SURNAME: 'Фамилия',
    SWITCH_LANGUAGE: 'Переключить язык',
    TAX_AUTHORITY_CODE: 'Код налогового органа',
    TAX_AUTHORITY_DISTRICT: 'Район налогового органа',
    TELEGRAM_USER_ID: 'Телеграм "user ID"',
    TELEPHONE: 'Телефон «сотовый»',
    TITLE: 'Название',
    TITLE_KG: 'Название (kg)',
    TITLE_RU: 'Название (ru)',
    TO_CANCEL: 'Отменить',
    TO_CONFIRM: 'На подтверждения',
    TO_LOGIN: 'Авторизоваться',
    TO_ME: 'Мне',
    TO_REGISTER: 'Зарегистрироваться',
    TO_RESOLUTION: 'На резолюции',
    TOTAL_AMOUNT: 'Общая сумма',
    TYPE: 'Тип',
    TYPE_EXPERTIZE: 'Вид экспертизы',
    TYPE_OF_APPLICANT: 'Тип заявителя',
    TYPES: 'Типы',
    UCHNUM: 'Номер участка',
    UGNS_KKN: 'УГНС по ККН',
    UNIT_NAME: 'Наименование подразделения',
    UNIT_OF_MEASUREMENT: 'Единица измерения',
    UPDATE: 'Обновить',
    UPLOAD_DATE: 'Дата загрузки',
    USER_NOT_FOUND: 'Пользователь не найден',
    USERNAME: 'Имя пользователя',
    USERS: 'Пользователи',
    VALIDATION_DATE: 'Дата не совпадает требованиям.',
    VALUE: 'Значение',
    VERSION: 'Версия',
    VERSIONS: 'Версии',
    VILLAGE: 'Село',
    WAITING_YOUR_ACTIONS: 'Ожидаются Ваши действия',
    WAITING_PAYMENT_CALCULATION: 'Ожидание расчета оплаты',
    WAITING_REGISTRATION: 'Ждет регистрацию',
    WAITING_SEND_TO_APPLICANT: 'Ожидает отправки',
    WHEN_ISSUED: 'Когда выдан',
    WHOOPS_SOMETHING_WENT_WRONG: 'Упс, похоже, что-то пошло не так!',
    WORK_PHONE: 'Телефон «рабочий»',
    WORKING_MODE: 'Режим работы',
    WROTE_REMARKS_TO_THE_RESOLUTION: '<span class="font-medium">:author</span> написал(а) замечане к резолюцие',
    YES: 'Да',
    YOU_CURATOR: 'Вы куратор',
    YOU_RESPONSIBLE: 'Вы "О" исполнитель',
}
